import {
  GET_APPOINTMENT_DETAILS,
  GET_APPOINTMENT_DETAILS_FAILURE,
  GET_APPOINTMENT_DETAILS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAppointmentDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENT_DETAILS:
      return { ...state, loading: true };
    case GET_APPOINTMENT_DETAILS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_APPOINTMENT_DETAILS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentDetailsReducer;
